export default __webpack_public_path__ + "static/media/feedPlant.a54df32f.png";